import { Component, OnInit } from '@angular/core';
import { RouteService } from '../../services/route';
import { MapComponent } from '@maplibre/ngx-maplibre-gl';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { Delivery } from '../../services/app/delivery-service';

@Component({
  selector: 'app-delivery-details',
  standalone: true,
  imports: [CommonModule, MatCardModule, MapComponent],
  templateUrl: './delivery-details.html',
  styleUrl: './delivery-details.css',
})
export class DeliveryDetailsComponent implements OnInit {
  delivery: Delivery;
  constructor(private routeService: RouteService) {

  }

  onMapLoaded() {
    console.log('Map loaded successfully');
  }

  onMapError(event: any) {
    console.error('Map error:', event);
  }

  async ngOnInit(): Promise<void> {
    this.delivery = new Delivery();//await this.routeService.getDeliveryById(1);


  }

}
